var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.200195,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0F0FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2002 27C34.5752 27 36.5752 28.625 37.0752 30.875C37.2002 31.5 37.9502 32 38.5752 31.75C39.2002 31.625 39.7002 30.875 39.4502 30.25C38.7002 26.75 35.7002 24.5 32.2002 24.5C28.0752 24.5 24.7002 27.875 24.7002 32C24.7002 35.875 27.7002 39.125 31.5752 39.5H31.7002C32.3252 39.5 32.8252 39 32.9502 38.375C33.0752 37.75 32.4502 37.125 31.8252 37C29.3252 36.75 27.2002 34.5 27.2002 32C27.2002 29.25 29.4502 27 32.2002 27Z",
    fill: "#6366F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2002 42C26.7002 42 22.2002 37.5 22.2002 32C22.2002 26.5 26.7002 22 32.2002 22C37.4502 22 41.8252 26.125 42.2002 31.375C42.2002 32.125 42.8252 32.625 43.5752 32.5C44.3252 32.5 44.8252 31.875 44.7002 31.125C44.2002 24.625 38.8252 19.5 32.2002 19.5C25.3252 19.5 19.7002 25.125 19.7002 32C19.7002 38.875 25.3252 44.5 32.2002 44.5C32.9502 44.5 33.4502 44 33.4502 43.25C33.4502 42.5 32.9502 42 32.2002 42Z",
    fill: "#6366F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8242 35.1251C43.6992 35.0001 43.4492 34.8751 43.3242 34.8751L35.1992 32.1251C34.4492 31.8751 33.5742 32.1251 32.9492 32.7501C32.3242 33.3751 32.1992 34.2501 32.5742 35.0001L36.3242 43.2501C36.6992 44.0001 37.4492 44.5001 38.1992 44.5001H38.5742C39.5742 44.3751 40.1992 43.6251 40.3242 42.6251L40.6992 39.6251L43.1992 38.8751C43.9492 38.6251 44.5742 38.0001 44.6992 37.1251C44.8242 36.3751 44.4492 35.5001 43.8242 35.1251ZM39.8242 37.2501C38.9492 37.5001 38.4492 38.1251 38.3242 39.0001L38.0742 40.8751L35.3242 34.7501L41.3242 36.7501L39.8242 37.2501Z",
    fill: "#6366F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/Budget .a95afa4d4fb239ad57a218148d9cca19.svg";
export { ForwardRef as ReactComponent };